import layout from '../layout'
export default function makeEventRoutes({
  contentType,
  components: { EventListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/${contentType.name}/list`,
          component: EventListingContainer,
          props: {
            contentType
          }
        }
      ]
    }
  ];
}
